import React, { useState, useEffect } from 'react';
import Button from 'apollo-react/components/Button';
import CommentsForm from '../FormApproveComponents/CommentsForm';
import MessagesBubbleAdd from 'apollo-react-icons/MessagesBubbleAdd';

const CommentToggle = ({
  onAddComment,
  persona,
  subFormId = null,
  buttonText = 'Comment',
  buttonProps = {},
  initiallyOpen = false,
  hasComments = false,
  buttonContainerProps = {},
  hideTitleSeparator = false,
  buttonAddCommentText,
  headerText,
}) => {
  const shouldShowFormInitially = initiallyOpen || !hasComments;
  const [showCommentForm, setShowCommentForm] = useState(
    shouldShowFormInitially
  );

  useEffect(() => {
    if (!initiallyOpen) {
      setShowCommentForm(!hasComments);
    }
  }, [hasComments, initiallyOpen]);

  const handleAddCommentWithClose = async (
    comment,
    subFormIdParam,
    fileId,
    fileData
  ) => {
    try {
      await onAddComment(
        comment,
        subFormIdParam || subFormId,
        fileId,
        fileData
      );
      setShowCommentForm(false); // Close form after successful submission
    } catch (error) {
      console.error('Error adding comment:', error);
      throw error;
    }
  };

  return (
    <>
      {!showCommentForm && (
        <div {...buttonContainerProps}>
          <Button
            variant="secondary"
            size="small"
            endIcon={<MessagesBubbleAdd size={11} />}
            onClick={() => setShowCommentForm(!showCommentForm)}
            sx={{
              ...buttonProps.sx,
              minWidth: 'auto',
              width: '180px',
              height: '29px',
              fontSize: '14px',
              padding: '4px 22.5px',
              backgroundColor: 'transparent !important',
              gap: '4px',
              marginBottom: 2,
              '& .MuiButton-endIcon': {
                marginLeft: '2px !important',
              },
            }}
          >
            <span style={{ fontWeight: 400 }}>{buttonText}</span>
          </Button>
        </div>
      )}

      {showCommentForm && (
        <CommentsForm
          subFormId={subFormId}
          onAddComment={handleAddCommentWithClose}
          onClose={() => setShowCommentForm(false)}
          persona={persona}
          hideCancelButton={!hasComments}
          hideTitleSeparator={hideTitleSeparator}
          buttonAddCommentText={buttonAddCommentText}
          headerText={headerText}
        />
      )}
    </>
  );
};

export default CommentToggle;
